export const jsonDistinctFunction = (a, b) => JSON.stringify(a) === JSON.stringify(b);
